import { useState } from "react";
import { Moon, Sun, Palette } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";
import { useAuth, useTheme } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

const PRESETS = ["#2563eb", "#059669", "#dc2626", "#ea580c", "#7c3aed", "#0891b2", "#db2777", "#ca8a04"];

export function AppearanceTab({ isAdmin }) {
  const { session, refresh } = useAuth();
  const [theme, toggleTheme] = useTheme();
  const t = session.tenant;
  const [color, setColor] = useState(t.settings.brand_color || "#2563eb");
  const save = async () => {
    try {
      await api.put("/settings", { razao_social: t.razao_social, nome_fantasia: t.nome_fantasia, telefone: t.telefone, endereco: t.endereco, segmento: t.segmento, settings: { brand_color: color } });
      await refresh();
      toast.success("Cor do sistema atualizada");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="grid md:grid-cols-2 gap-4">
      <div className="card-surface p-5 space-y-4" data-testid="appearance-color-card">
        <p className="font-semibold flex items-center gap-2"><Palette className="h-4 w-4 text-primary" />Cor do estabelecimento</p>
        <p className="text-sm text-muted-foreground">Usada nos botões e destaques do sistema e no cardápio digital.</p>
        <div className="flex flex-wrap gap-2">
          {PRESETS.map((c) => <button key={c} onClick={() => setColor(c)} disabled={!isAdmin} aria-label={`Cor ${c}`} className={`h-9 w-9 rounded-full ring-offset-2 ring-offset-background transition-transform hover:scale-110 ${color === c ? "ring-2 ring-foreground" : ""}`} style={{ background: c }} data-testid={`color-preset-${c.slice(1)}`} />)}
        </div>
        <Field label="Cor personalizada"><div className="flex gap-2"><input type="color" value={color} onChange={(e) => setColor(e.target.value)} disabled={!isAdmin} className="h-10 w-14 rounded border" data-testid="brand-color-picker" /><Input value={color} onChange={(e) => setColor(e.target.value)} disabled={!isAdmin} data-testid="brand-color-input" /></div></Field>
        {isAdmin ? <Button onClick={save} data-testid="save-brand-color-btn">Salvar cor</Button> : <p className="text-xs text-muted-foreground">Apenas administradores podem alterar a cor.</p>}
      </div>
      <div className="card-surface p-5 space-y-4">
        <p className="font-semibold">Modo de exibição</p>
        <p className="text-sm text-muted-foreground">Escolha entre o modo claro e o escuro. A preferência fica salva neste aparelho.</p>
        <Button variant="outline" size="lg" onClick={toggleTheme} data-testid="appearance-theme-btn">
          {theme === "dark" ? <><Sun className="h-4 w-4 mr-2" />Usar modo claro</> : <><Moon className="h-4 w-4 mr-2" />Usar modo escuro</>}
        </Button>
      </div>
    </div>
  );
}
